const seitup = {
    _unisex_mode: '',
    init: function() {
        console.info('seitup unisex mode plugin is active')
        this._unisex_mode = window.localStorage.getItem('seitup.unisex_mode.mode');
        this.updateImages()
    },
    setUnisexMode: function(mode) {
        this._unisex_mode = mode;
        this.save();
        this.updateImages();
    },
    save: function() {
        window.localStorage.setItem('seitup.unisex_mode.mode',this._unisex_mode)
    },
    updateImages: function() {
        const m = this._unisex_mode
        const male = m === 'm';
        const female = m === 'f';
        const any = !m;

        const images = document.querySelectorAll('product-gallery img');
        console.info(`${images.length} found on the page`);

        images.forEach( (el) => {
            const alt = el.alt;

            if (any) {
                el.style.display = 'block'
                return
            }
            if (male) {
                if (alt.match(/-male$/)) {
                    el.style.display = 'block'
                }
                if (alt.match(/-female$/)) {
                    el.style.display = 'none'
                }
                return
            }
            if (female) {
                if (alt.match(/-female$/)) {
                    el.style.display = 'block'
                }
                if (alt.match(/-male$/)) {
                    el.style.display = 'none'
                }
            }
        })
    }
}

window.addEventListener('load', () => {
    seitup?.init();
}, false);

window.seitup = seitup;


